import React from 'react';
import ReactDOM from 'react-dom';
import {
  BrowserRouter as Router,
  Route,
  Routes
} from 'react-router-dom';
import RenderWebshopArticleView from './components/RenderWebshopArticle/RenderWebshopArticleView';
import WebshopItemTranslatorFormView from './components/WebshopItemTranslatorForm/WebshopItemTranslatorFormView';

// Example components
const HomePage = () => <h1>Home Page</h1>;
const WebshopItemViewer = () => <h1>Webshop Item Viewer</h1>;

// Entry point function
export default function initStandalonePage() {
  ReactDOM.render(
    <React.StrictMode>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/webshop/viewer/item" element={<RenderWebshopArticleView />} />
          <Route path="/webshop/forms/item-translator" element={<WebshopItemTranslatorFormView />} />
        </Routes>
      </Router>
    </React.StrictMode>,
    document.getElementById('root')
  );
}